export enum AdminTreatmentPropertyStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
